module.exports = __webpack_public_path__ + "img/1_gif.b137b62a.gif";